import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import { Section, Container } from '@/components/ui/Section';

export function Privacy() {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;

  const dataCollectedItems = t('privacy.sections.dataCollected.items', { returnObjects: true }) as string[];
  const purposesItems = t('privacy.sections.purposes.items', { returnObjects: true }) as string[];
  const legalBasisItems = t('privacy.sections.legalBasis.items', { returnObjects: true }) as string[];
  const rightsItems = t('privacy.sections.rights.items', { returnObjects: true }) as string[];

  return (
    <>
      <Helmet>
        <title>{t('privacy.pageTitle')}</title>
        <meta name="description" content={t('privacy.metaDescription')} />
        <link rel="canonical" href={`https://www.01sistemi.it/${currentLang}/privacy/`} />
      </Helmet>

      {/* Hero Section */}
      <Section className="bg-gradient-to-br from-secondary-50 to-white" padding="md">
        <Container size="narrow">
          <div className="text-center">
            <span className="caption text-primary-400">{t('privacy.overline')}</span>
            <h1 className="heading-1 mt-4">{t('privacy.heroTitle')}</h1>
            <p className="body-regular mt-4 text-gray-500">
              {t('privacy.lastUpdated', { date: '17 Febbraio 2026' })}
            </p>
          </div>
        </Container>
      </Section>

      {/* Content Section */}
      <Section>
        <Container size="narrow">
          <div className="prose prose-lg max-w-none">
            <section className="mb-8">
              <h2 className="heading-3 mb-4">{t('privacy.sections.controller.title')}</h2>
              <p className="body-regular mb-4">
                {t('privacy.sections.controller.description')}
              </p>
              <p className="body-regular">
                <strong>{t('privacy.sections.controller.contactsLabel')}</strong><br />
                {t('privacy.sections.controller.email')}<br />
                {t('privacy.sections.controller.pec')}<br />
                {t('privacy.sections.controller.phone')}
              </p>
            </section>

            <section className="mb-8">
              <h2 className="heading-3 mb-4">{t('privacy.sections.dataCollected.title')}</h2>
              <p className="body-regular mb-4">
                {t('privacy.sections.dataCollected.description')}
              </p>
              <ul className="list-disc pl-6 space-y-2 body-regular">
                {dataCollectedItems.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="heading-3 mb-4">{t('privacy.sections.purposes.title')}</h2>
              <p className="body-regular mb-4">
                {t('privacy.sections.purposes.description')}
              </p>
              <ul className="list-disc pl-6 space-y-2 body-regular">
                {purposesItems.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="heading-3 mb-4">{t('privacy.sections.legalBasis.title')}</h2>
              <p className="body-regular mb-4">
                {t('privacy.sections.legalBasis.description')}
              </p>
              <ul className="list-disc pl-6 space-y-2 body-regular">
                {legalBasisItems.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="heading-3 mb-4">{t('privacy.sections.retention.title')}</h2>
              <p className="body-regular">
                {t('privacy.sections.retention.description')}
              </p>
            </section>

            <section className="mb-8">
              <h2 className="heading-3 mb-4">{t('privacy.sections.rights.title')}</h2>
              <p className="body-regular mb-4">
                {t('privacy.sections.rights.description')}
              </p>
              <ul className="list-disc pl-6 space-y-2 body-regular">
                {rightsItems.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="heading-3 mb-4">{t('privacy.sections.cookies.title')}</h2>
              <p className="body-regular">
                {t('privacy.sections.cookies.description')}
              </p>
            </section>

            <section>
              <h2 className="heading-3 mb-4">{t('privacy.sections.contact.title')}</h2>
              <p className="body-regular">
                {t('privacy.sections.contact.description')} <a href="mailto:info@01s.it" className="text-primary-400 hover:underline">info@01s.it</a>
              </p>
            </section>
          </div>
        </Container>
      </Section>
    </>
  );
}
